import { useQuery } from 'react-query'
import { apiClient } from '@/services/apiClient'
import type { SubscriptionPriceListResponse } from '@/types/api'

export const SUBSCRIPTION_PRICES_QUERY_KEY = ['subscription-prices'] as const

/**
 * Справочник тарифов подписки. Кешируется на 5 минут — данные редко меняются.
 */
export const useSubscriptionPricesQuery = (enabled = true) => {
  return useQuery<SubscriptionPriceListResponse>(
    SUBSCRIPTION_PRICES_QUERY_KEY,
    () => apiClient.getSubscriptionPrices(),
    {
      enabled,
      staleTime: 5 * 60_000,
      cacheTime: 10 * 60_000,
      retry: 1,
    }
  )
}
